import { render, staticRenderFns } from "./terminalRFIDLogs.vue?vue&type=template&id=d3a865c8&scoped=true"
import script from "./terminalRFIDLogs.vue?vue&type=script&lang=js"
export * from "./terminalRFIDLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a865c8",
  null
  
)

export default component.exports